import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useCreateSubagent = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["create_subagent"],
    mutationFn: async (query) => {
      const res = await axios.post("/createsubagent", query);
      return res.data;
    },
  });
};
